module.exports = __webpack_public_path__ + "img/i_c_key_01.86d83c4a.svg";